import React, { useState } from 'react';
import styles from './MainCardSelectModal.module.css';

import { InnocodePaymentCardInfo, InnocodePaymentPasswordButton, InnocodePaymentPasswordDot } from '@intsoft/innocode-payment';
import { InnocodeButton, useDialog, InnocodeLoading } from '@intsoft/innocode-core';

interface cardInfo {
    id: string;
    cardNumber?: string;
    cardType: string;
    cardBrand: string;
    cardBankType?: string;
    cardBrandName?: string;
    cardName?: string;
    billingKey?: string;
    status: "active" | "inactive";
}

/* 비밀번호 입력/생성/수정 모달 */
interface MainCardSelectModalProps {
    title?: string;
    confirmText?: string;
    cardList: cardInfo[];
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: (card: cardInfo) => void;
}

export const MainCardSelectModal: React.FC<MainCardSelectModalProps> = (props: MainCardSelectModalProps) => {
    const { title, confirmText } = props;
    const [selectedCard, setSelectedCard] = useState<cardInfo | null>(null);
    const { showDialog } = useDialog();

    const handleConfirm = () => {
        if (selectedCard) {
            props.onConfirm?.(selectedCard);
            props.onClose();
        } else {
            showDialog({
                type: 'error',
                iconType: 'warning',
                title: '카드를 선택해주세요.',
                confirmText: '완료',
                onConfirm: () => {

                }
            })
        }
    };

    return (
        <div className={styles.layoutContainer}>
            <div className={styles.editorHeader}>
                <div className={styles.editorHeaderCloseButton} onClick={props.onClose}>
                    <svg className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" onClick={props.onClose} style={{ cursor: 'pointer' }}>
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                </div>
            </div>
            <div className={styles.scrollContentArea}>
                <div className={styles.minHeightArea}>
                    <div className={styles.contentAreaWrapper}>
                        <div className={styles.contentArea}>
                            <div className={styles.contentAreaTitle}>
                                <h1 className={`innocode-typography--headline-sm innocode-typography--bold ${styles.contentAreaTitleText}`}>
                                    {title ? title : "대표카드 선택"}
                                </h1>
                            </div>
                            <div className={styles.cardArea}>
                                {props.cardList.map((card: cardInfo) => (
                                    <InnocodePaymentCardInfo
                                        key={card.id}
                                        showBadge={card.status === "active" ? true : false}
                                        cardNumber={`${card.cardNumber} ${card.cardType}`}
                                        cardType={card.cardType}
                                        cardBankType={card.cardBankType}
                                        cardBankName={card.cardName}
                                        cardName={card.cardName}
                                        status={selectedCard?.id === card.id ? 'pressed' : 'default'}
                                        onClick={() => setSelectedCard(card)}
                                    ></InnocodePaymentCardInfo>
                                ))}
                            </div>
                            <div className={styles.actionButtonWrapper}>
                                <InnocodeButton size={"xl"} className={styles.actionButton} onClick={handleConfirm}>{confirmText ? confirmText : "대표카드로 등록하기"}</InnocodeButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};